import { Container, Stack } from "@mantine/core";
import { DeleteAccountCard } from "../../components/profile/DeleteAccountCard";
import { PageHeader } from "../../components/ui";
import { ACCOUNT_COPY } from "../../constants/account";
import { axioTokens } from "../../theme";

export function DeleteAccountPage() {
  return (
    <Container size="sm" py="xl">
      <Stack gap={axioTokens.unit[40]}>
        <PageHeader title={ACCOUNT_COPY.deletePageTitle} subtitle={ACCOUNT_COPY.deletePageSubtitle} />
        <DeleteAccountCard />
      </Stack>
    </Container>
  );
}
